import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { fontStyles } from 'theme';

export const Container = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  background-color: var(--color-white);
  text-decoration: none !important;
`;

export const Image = styled.img`
  width: 100%;
  aspect-ratio: 2/1;
  object-fit: contain;
  object-position: center bottom;
  background-color: var(--color-grey-d8);
  border-radius: 16px 16px 0 0;
`;

export const Title = styled.p`
  ${fontStyles.font20}
  text-align: center;
  padding: 10px;
`;

export const LabelWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  padding: 15px 8px;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  & > span {
    ${fontStyles.smallBold}
  }
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 33px;
  min-width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color || '#ebebeb'};
`;
